// Base
import { BaseApi } from '../base.api'

// Interface
import {
  IGalleryWebpageApi,
  IGalleryWebpageApiRequest,
  IGalleryWebpageApiResponse,
  IGalleryWebpageGetAttrs,
} from 'interfaces/webpage/gallery'

// Constant
import { ApiConstant } from 'constant'
import { axios_renderUrl } from 'utils'

export class GalleryWebpageApi extends BaseApi<IGalleryWebpageApi> implements IGalleryWebpageApiRequest {
  readonly url = ApiConstant.GALLERY_URL
  private galleryUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get gallery webpage
   *
   * @method POST
   * @url /gallery
   * @access public
   *
   * @return {Promise<IGalleryWebpageApiResponse>} Promise<IGalleryWebpageApiResponse>
   */
  async galleryWebpage_getGallery(payload: IGalleryWebpageGetAttrs): Promise<IGalleryWebpageApiResponse> {
    try {
      const response: IGalleryWebpageApiResponse = await this.POST(this.galleryUrl, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
